module.exports = "\r\n.all-width {\r\n  width: 100%;\r\n  margin-top: 0.5em;\r\n}\r\n\r\n.etiqueta {\r\n  font-size: 14px;\r\n  color: #999;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/diagnosticos-edicion/diagnosticos-edicion.component.css
// module id = ./src/app/diagnosticos-edicion/diagnosticos-edicion.component.css
// module chunks = main